<template>
    <div class="loader">
        <v-overlay
            style='z-index:2000;'
            :value="isLoading"
            :opacity="opacity"
            :color="color"
        >
        <div class="text-center">
            <div >
                <span class="loader-dot"></span>
                <span class="loader-dot"></span>
                <span class="loader-dot"></span>
                <span class="loader-dot"></span>
            </div>
            <p class="loader-text">Please wait!</p>
            <p class="loader-text-processing"> {{ message }} </p>
        </div>
        </v-overlay>
    </div>
</template>

<script>

export default {
    name: 'Loader',
    data () {
        return {
            isLoading: false,
            opacity: 1,
            color: '#ffffff',
            message: null
        }
    },
    created () {
        this.message = this.$store.getters.getLoaderMessage
    },
    watch: {
        '$store.state.isLoading': {
            handler (newValue, oldValue) {
                this.isLoading = newValue
            },
            deep: true,
            immediate: true
        },
        '$store.state.loaderMessage': {
            handler (newValue, oldValue) {
                this.message = newValue
            },
            deep: true,
            immediate: true
        }
    }
}
</script>

<style scoped>

.loadingAnimation {
    display: flex;
}
.loader-text {
    color: #232323;
    font-size: 18px;
    font-weight: 600;
    margin-top: 10px;
    margin-bottom: 2px !important
}
.loader-text-processing {
    color: #232323;
    font-size: 14px;
    font-weight: 500;
    margin-top: 2px;
}
@keyframes scaling{
  0%, 100%{
    transform: scale(1.2);
    background-color: #ffdf65;
  }
  40%{
    transform: scale(1);
    background-color: #002fa7;
  }
  50%{
    transform: scale(1);
    background-color: #002fa7;
  }
}

.loader-dot {
    height: 22px;
    width: 22px;
    border-radius:50%;
    transform: scale(0);
    background-color:red;
    animation: scaling 2.5s ease-in-out infinite;
    display: inline-block;
    margin:.5rem;
}

.loader-dot:nth-child(0){
  animation-delay:0s;
}
.loader-dot:nth-child(1){
  animation-delay:0.2s;
}
.loader-dot:nth-child(2){
  animation-delay:0.4s;
}
.loader-dot:nth-child(3){
  animation-delay:0.6s;
}
.loader-dot:nth-child(4){
  animation-delay:0.8s;
}
.loader-dot:nth-child(5){
  animation-delay:1s;
}
.loaderContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
}

</style>
